import {AfterViewInit, Component, Output,  Input,EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {Observable, of, from} from "rxjs";
import {MaterialInstance, MaterialService} from "../../shared/classes/material.service";
import {Subscription} from "rxjs";
import {StreamsService}  from "../../shared/services/streams.service";
import {StreamProject} from "../../shared/interfaces";
import { switchMap, delay} from 'rxjs/operators';
import {WatchTokenService}  from "../../shared/services/watch-token.service";
 import {SocketQrEnterWatch} from '../../shared/services/sockets'
 import { NbDialogService,NbGlobalPosition, NbToastrService } from '@nebular/theme';
  import {domain, protocol} from '../../shared/config';
 import {PaymentBuyCodeModalComponent}  from '../../shared/components/payment-buy-code-modal/payment-buy-code-modal.component';

 
@Component({
  selector: 'app-access-embed',
  templateUrl: './access-embed.component.html',
  styleUrls: ['./access-embed.component.scss'],
  
})
export class AccessEmbedComponent implements OnInit, OnDestroy {

 
  @Input() stream: StreamProject
  @Output() onAuth = new EventEmitter()
   @Input() sessionKey:string = ''
  @Input() codeFromEmbed: any = null
 
  load: boolean = false;
  serverSubscribe: any = null
  password: string = ''
  qrLink: string = ''

  modal:any = null



  constructor(
    public streamsService: StreamsService,
    public tokenService: WatchTokenService,
  private socket: SocketQrEnterWatch,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
    ){
    // this.socket.removeAllListeners()
     // this.socket.disconnect()
  } 


  ngOnInit() { 

this.qrLink = `${protocol}${domain}/qr-enter/${this.stream.publicIdentity}/${this.sessionKey}`
	const socketKey = this.stream.publicIdentity+'_'+this.sessionKey

				
 
		    this.socket.on('onCommand', this.onCommand.bind(this))
			
		  //  this.socket.on('exitByToken', this.exitByToken.bind(this))



		  this.socket.on('connect', ()=>{
		      this.socket.emit('onJoin', 
		       {
			enterPageIdent: 'epj_'+ socketKey,
			watchKey:  socketKey
			}
		      )
		    })

		this.socket.connect()

	        
	if(this.codeFromEmbed){
		
		 this.submitFromQr(this.codeFromEmbed)
	}
	
  }

 
   onCommand({cmd, payload}){

     if(cmd === 'keyEnter'){
		 

                this.submitFromQr(payload.key)
		return
	}



  }

  get isEnglish(){
  
   return ['e017f1c0' , '43de735f' , 'aada46cb' , 'ccfabee3', '0432f141','0bbac3f1', '0d29511e', '8ab1af07', 'ced3e648','a7b77c92', '7900e957'].includes(this.stream.publicIdentity)
  
  }
  get isBlackButton(){
    return ['27daeeca' , '1625e5c4', 'e1182f93', '2978ba7f'   ].includes(this.stream.publicIdentity)

  }
  buyNowKey(){
 

		 this.dialogService.open(PaymentBuyCodeModalComponent, {
			      context: {
				stream: this.stream,
				onCode: (code:string)=>this.unlockWithCode(code)
			      },
				
			     closeOnEsc: false,
				closeOnBackdropClick: false
			    });

  } 



    
  unlockWithCode(code:string):Promise<boolean>{
    return new Promise((resolve)=>{
      this.streamsService.authWatchAccessToken(this.stream._id, code).subscribe((data:any)=>{
        if(data && data.token){
          this.tokenService.setToken(this.stream.publicIdentity, data.token)
          this.onAuth.emit({success: true})
          resolve(true)
          return
        }
        resolve(false)
      }, ()=>resolve(false))
    })
  }

  submitFromQr(key){

   
    
    if(this.serverSubscribe){
      this.serverSubscribe.unsubscribe()
      this.serverSubscribe = null
    }

    if(key === ''){
    //  MaterialService.toast('Ключ не должен быть пустым')

  
		 
      return
    }

 
    this.load = true
    this.serverSubscribe = this.streamsService
    .authWatchAccessToken(this.stream._id, key ).subscribe((data:any)=>{

      if(data.error){
 
  

       this.socket.emit('onKeyResponce', {type:'error'})
        this.load = false
        return
      }

      if(data.token){

	this.socket.emit('onKeyResponce', {type:'success'})
        this.tokenService.setToken(this.stream.publicIdentity, data.token)
        this.onAuth.emit({
          success: true
        })
      }  
      
      this.load = false


    })


   
    
  }




 
  submit(){

   
    
    if(this.serverSubscribe){
      this.serverSubscribe.unsubscribe()
      this.serverSubscribe = null
    }

    if(this.password === ''){
     // MaterialService.toast('Ключ не должен быть пустым')
      return
    }

 
    this.load = true
    this.serverSubscribe = this.streamsService
    .authWatchAccessToken(this.stream._id, this.password ).subscribe((data:any)=>{

      if(data.error){
       this.toastrService.show(``,( this.isEnglish  ? "Invalid key" : 'Невірний ключ' ),{
			status: 'danger',
			position: <NbGlobalPosition>'bottom-end',
			icon: ''
		      })
		 
        this.load = false
        return
      }

      if(data.token){


	this.socket.emit('onKeyResponce', {type:'success'})
        this.tokenService.setToken(this.stream.publicIdentity, data.token)
        this.onAuth.emit({
          success: true
        })
      }  
      
      this.load = false


    })


   
    
  }


  
  openQrModal(content) {
   
    this.modal = this.dialogService.open(content,{hasScroll: true} )
  
    
  }
  
  
 

  
   ngOnDestroy() { 
  
	    if(this.serverSubscribe){
	      this.serverSubscribe.unsubscribe()
	    }
		if(this.modal){ try{ this.modal.close() }catch(e){} }

	   this.socket.disconnect()
	    // this.socket.removeAllListeners()
	  this.socket.removeAllListeners('onCommand')
		this.socket.removeAllListeners('connect') /* */
	 
   }


}
